/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'file-word-fill': {
    width: 16,
    height: 16,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 566.095l52.814 197.012a12 12 0 0011.59 8.893h31.78a12 12 0 0011.587-8.878l74.375-276a12 12 0 00.413-3.122c0-6.627-5.373-12-12-12h-35.576a12 12 0 00-11.695 9.31l-45.79 199.105-49.76-199.321A12 12 0 00528.097 472h-32.192a12 12 0 00-11.643 9.094l-49.66 198.927-46.096-198.732a12 12 0 00-11.69-9.289h-35.381a12 12 0 00-3.115.411c-6.4 1.72-10.194 8.303-8.474 14.703l74.173 276A12 12 0 00415.606 772h31.99a12 12 0 0011.59-8.893L512 566.095z"/>'
  }
})
